import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';
import moduleMargins from '../../../vars/moduleMargins';

export const Container = styled.div`
    max-width: 1440px;
    padding: 0 ${gutters['container-gutters-desktop-l']};
    margin: 0 auto;
    box-sizing: content-box;    
    @media (max-width: ${breakpoints['bp-desktop']}) {
        max-width: 930px;
        padding: 0 ${gutters['container-gutters-desktop']};
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        max-width: 700px;
        padding: 0 ${gutters['container-gutters-tablet']};
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        padding: 0 ${gutters['container-gutters-mobile']};
        max-width: 100%;
        overflow: hidden;
    }
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: ${gutters['row-gutters-desktop-l']};
    margin-right: ${gutters['row-gutters-desktop-l']};
    margin-top: ${props => (props.margins !== false) ? (props => (props.margins && props.margins[0] !== undefined) ? props => props.margins[0] : moduleMargins['desktop-l']) : '0'}px;
    @media (max-width: ${breakpoints['bp-desktop']}) {
        margin-left: ${gutters['row-gutters-desktop']};
        margin-right: ${gutters['row-gutters-desktop']};
        margin-top: ${props => (props.margins !== false) ? (props => (props.margins && props.margins[1] !== undefined) ? props => props.margins[1] : moduleMargins['desktop']) : '0'}px;
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        margin-left: ${gutters['row-gutters-tablet']};
        margin-right: ${gutters['row-gutters-tablet']};
        margin-top: ${props => (props.margins !== false) ? (props => (props.margins && props.margins[2] !== undefined) ? props => props.margins[2] : moduleMargins['tablet']) : '0'}px;
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        margin-left: ${gutters['row-gutters-mobile']};
        margin-right: ${gutters['row-gutters-mobile']};
        margin-top: ${props => (props.margins !== false) ? (props => (props.margins && props.margins[3] !== undefined) ? props => props.margins[3] : moduleMargins['mobile']) : '0'}px;
    }
    ${props => props.cblockPaddingTop && css`
        padding-top: calc(${gutters['container-gutters-desktop-l']} * 0.7);
        @media (max-width: ${breakpoints['bp-desktop']}) {
            padding-top: calc(${gutters['container-gutters-desktop']} * 0.7);
        }
        @media (max-width: ${breakpoints['bp-tablet']}) {
            padding-top: calc(${gutters['container-gutters-tablet']} * 0.7);
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            padding-top: calc(${gutters['container-gutters-mobile']} * 0.7);
        }
    `
    }
`;

export const Column = styled.div`
    ${ props => props.flex && css`
        display: flex;
    `}    
    flex: ${props => props.cw ? `0 0 ${ (props.cw / 12) * 100 }%` : '1 1 auto'};
    max-width: ${props => props.cw ? `${ (props.cw / 12) * 100 }%` : 'none'};
    margin-left: ${props => props.offset ? `calc((${props.offset / 12}) * 100%)` : '0'};
    box-sizing: border-box;
    padding-left: ${gutters['column-gutters-desktop-l']};
    padding-right: ${gutters['column-gutters-desktop-l']};
    @media (max-width: ${breakpoints['bp-desktop']}) {
        padding-left: ${gutters['column-gutters-desktop']};
        padding-right: ${gutters['column-gutters-desktop']};
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        padding-left: ${gutters['column-gutters-tablet']};
        padding-right: ${gutters['column-gutters-tablet']};
        ${ props => props.tcw && css`
            flex: ${props => props.tcw ? `0 0 ${ (props.tcw / 12) * 100 }%` : '1 1 auto'};
            max-width: ${props => props.tcw ? `${ (props.tcw / 12) * 100 }%` : 'none'};
        `
        }
        ${ props => props.tOffset && css`
            margin-left: ${props => props.tOffset ? `calc((${props.tOffset / 12}) * 100%)` : '0'};
        `
        }
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        max-width: 100%;
        padding-left: ${gutters['column-gutters-mobile']};
        padding-right: ${gutters['column-gutters-mobile']};
        flex: ${props => props.mcw ? `0 0 ${ (props.mcw / 4) * 100 }%` : '0 0 100%'};
        margin-left: ${props => props.mobileOffset ? `calc((${props.mobileOffset / 4}) * 100%)` : '0'};
    }
`;



// WEBPACK FOOTER //
// ./src/components/global/grid/grid.js